/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteGcpIamPlatformCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteGcpIamPlatformCredentialRequest = {
  /**
   * The ID of the credential to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteGcpIamPlatformCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGcpIamPlatformCredentialSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteGcpIamPlatformCredentialSecurity$Outbound,
    DeleteGcpIamPlatformCredentialSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteGcpIamPlatformCredentialSecurityToJSON(
  deleteGcpIamPlatformCredentialSecurity:
    DeleteGcpIamPlatformCredentialSecurity,
): string {
  return JSON.stringify(
    DeleteGcpIamPlatformCredentialSecurity$outboundSchema.parse(
      deleteGcpIamPlatformCredentialSecurity,
    ),
  );
}

/** @internal */
export type DeleteGcpIamPlatformCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGcpIamPlatformCredentialRequest$outboundSchema:
  z.ZodMiniType<
    DeleteGcpIamPlatformCredentialRequest$Outbound,
    DeleteGcpIamPlatformCredentialRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function deleteGcpIamPlatformCredentialRequestToJSON(
  deleteGcpIamPlatformCredentialRequest: DeleteGcpIamPlatformCredentialRequest,
): string {
  return JSON.stringify(
    DeleteGcpIamPlatformCredentialRequest$outboundSchema.parse(
      deleteGcpIamPlatformCredentialRequest,
    ),
  );
}
